<template>
  <div class="spinner-page" v-if="areFileRecordsLoading">
    <q-spinner class="spinner" color="primary" size="3em" />
  </div>
  <div v-else class="file-records-overview">
    <div v-if="anyDoubleRows" class="duplicate-rows-container">
      <q-table
        class="duplicates-table"
        dense
        card-class="bg-red-1"
        title="Dubbele rijen"
        :columns="columns"
        :visible-columns="visibleColumns"
        :rows="doubleRows"
        :loading="loading"
        v-model:pagination="pagination"
        row-key="id"
        :selected-rows-label="getSelectedString"
        selection="multiple"
        v-model:selected="selected"
        @request="onRequest"
      >
      </q-table>
      <div v-if="anySelected" class="btn-container">
        <q-btn
          class="bg-green-1 q-mr-md"
          icon="check"
          @click="addRecords"
          label="Geselecteerde toevoegen"
        />
        <q-btn
          class="bg-red-1"
          icon="close"
          @click="rejectRecords"
          label="Verwijder geselecteerde"
        />
      </div>
    </div>
    <div class="main-container">
      <RecordsSideBarSearch />
      <div class="records-container">
        <q-table
          class="records-table"
          dense
          :title="fileName"
          :columns="columns"
          :visible-columns="visibleColumns"
          :rows="rows"
          v-model:pagination="pagination"
          :loading="loading"
          row-key="id"
          selection="multiple"
          v-model:selected="selectedDeleteRows"
          @request="onRequest"
        >
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td>
                <q-checkbox v-model="props.selected" color="primary" />
              </q-td>
              <q-td key="actions" :props="props">
                <i
                  v-if="props.row.editing != null && props.row.editing"
                  class="las la-2x la-save la-fw action-icon"
                  color="black"
                  @click="submitChanges(props.row)"
                >
                <q-tooltip>Save changes</q-tooltip>
                </i>
              </q-td>
              <q-td key="organisation" :props="props">
                {{ props.row.organisation }}
                <q-popup-edit
                  buttons
                  v-model="props.row.organisation"
                  v-slot="scope"
                  :validate="organisationValidation"
                  @hide="organisationValidation"
                  @save="updateEditingState(props.row)"
                >
                  <q-input
                    v-model="scope.value"
                    dense
                    autofocus
                    counter
                    @keyup.enter.stop
                    :error="errorOrganisation"
                    :error-message="errorOrganisationMessage"
                  />
                </q-popup-edit>
              </q-td>
              <q-td key="applicationNumber" :props="props">
                {{ props.row.applicationNumber }}
                <q-popup-edit
                  buttons
                  v-model="props.row.applicationNumber"
                  v-slot="scope"
                  :validate="applicationNumberValidation"
                  @hide="applicationNumberValidation"
                  @save="updateEditingState(props.row)"
                >
                  <q-input
                    v-model="scope.value"
                    dense
                    autofocus
                    counter
                    @keyup.enter.stop
                    :error="errorApplicationNumber"
                    :error-message="errorApplicationNumberMessage"
                  />
                </q-popup-edit>
              </q-td>
              <q-td key="applicationSubject" :props="props">
                {{ props.row.applicationSubject }}
                <q-popup-edit
                  buttons
                  v-model="props.row.applicationSubject"
                  v-slot="scope"
                  :validate="applicationSubjectValidation"
                  @hide="applicationSubjectValidation"
                  @save="updateEditingState(props.row)"
                >
                  <q-input
                    v-model="scope.value"
                    type="textarea"
                    dense
                    autofocus
                    counter
                    @keyup.enter.stop
                    :error="errorApplicationSubject"
                    :error-message="errorApplicationSubjectMessage"
                  />
                </q-popup-edit>
              </q-td>
                <q-td key="customer" :props="props">
                {{ props.row.customer }}
              </q-td>
              <q-td key="city" :props="props">
                {{ props.row.city }}
              </q-td>
              <q-td key="applicationDescription" :props="props">
                {{ props.row.applicationDescription }}
                <q-popup-edit
                  buttons
                  v-model="props.row.applicationDescription"
                  v-slot="scope"
                  @save="updateEditingState(props.row)"
                >
                  <q-input
                    v-model="scope.value"
                    type="textarea"
                    dense
                    autofocus
                    counter
                    @keyup.enter.stop
                  />
                </q-popup-edit>
              </q-td>
              <q-td key="dateGrantedString" :props="props">
                {{ props.row.dateGrantedString }}
              </q-td>
              <q-td key="formattedAmount" :props="props">
                {{ props.row.formattedAmount }}
              </q-td>
              <q-td key="programTarget" :props="props">
                {{ props.row.programTarget }}
                <q-popup-edit
                  buttons
                  v-model="props.row.programTarget"
                  v-slot="scope"
                  @save="updateEditingState(props.row)"
                >
                  <q-input
                    v-model="scope.value"
                    dense
                    autofocus
                    counter
                    @keyup.enter.stop
                  />
                </q-popup-edit>
              </q-td>
              <q-td key="schemeName" :props="props">
                {{ props.row.schemeName }}
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <q-btn
          v-if="anythingSelectedForRemoval"
          class="bg-red-1 q-mr-md"
          icon="las la-2x la-trash la-fw action-icon"
          @click="confirmRemoveRecords = true"
          label="Verwijder geselecteerde"
        />
      </div>
    </div>

    <q-dialog v-model="confirmRemoveRecords" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <i class="las la-2x la-trash la-fw"></i>
          <span class="q-ml-sm">
            Weet je zeker dat je alle geselecteerde gegevens wilt verwijderen?
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            style="background: #0a108f; color: white"
            label="Verwijder geselecteerde data"
            no-caps
            v-close-popup
            @click="removeRecords()"
          />
          <q-btn
            style="color: #0a108f; border: 1px solid gray; border-radius: 5px"
            no-caps
            label="Annuleren"
            flat
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
  <FileRecordsErrorModal />
</template>
<script>
import { ref, computed, onMounted, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import store from '../store/index.js';
import RecordsService from '../services/records.service';
import RecordsSideBarSearch from '../components/search-components/RecordsSideBarSearch.vue';
import FileRecordsErrorModal from '../components/FileRecordsErrorModal.vue';

export default {
  name: 'FileRecordsOverview',
  components: {
    RecordsSideBarSearch,
    FileRecordsErrorModal
  },
  setup() {
    const route = useRoute();
    const columns = [
      { name: 'id', label: 'Id', field: 'id', align: 'left' },
      { name: 'actions' },
      {
        name: 'organisation',
        label: 'Verstrekker',
        field: 'organisation',
        sortable: true,
        align: 'left',
      },
      {
        name: 'applicationNumber',
        label: 'Nummer verlening',
        field: 'applicationNumber',
        sortable: true,
        align: 'left',
      },
      {
        name: 'applicationSubject',
        label: 'Aanvraagtitel',
        field: 'applicationSubject',
        sortable: true,
        align: 'left',
      }, // renamed in #4269
      {
        name: 'customer',
        label: 'Ontvanger',
        field: 'customer',
        align: 'left',
      },
      {
        name: 'city',
        label: 'Plaats',
        field: 'city',
        sortable: true,
        align: 'left',
      },
      {
        name: 'applicationDescription',
        label: 'Samenvatting',
        field: 'applicationDescription',
        sortable: true,
        align: 'left',
      },
      // { name: 'dateTimeGranted', label: 'Verleningsdatum', field: 'dateTimeGranted', sortable: true },
      {
        name: 'dateGrantedString',
        label: 'Verleningsdatum',
        field: 'dateGrantedString',
        sortable: true,
        align: 'left',
      },
      // { name: 'amount', label: 'Verleend bedrag', field: 'amount', sortable: true },
      {
        name: 'formattedAmount',
        label: 'Verleend bedrag',
        field: 'formattedAmount',
        sortable: true,
        align: 'left',
      },
      // { name: 'themeArrangement', label: 'Thema regeling', field: 'themeArrangement', sortable: true , align: 'left' },
      // { name: 'goal', label: 'Doelstelling', field: 'goal', sortable: true , align: 'left' },
      // { name: 'programName', label: 'Programma naam', field: 'programName', sortable: true },
      {
        name: 'programTarget',
        label: 'Thema regeling',
        field: 'programTarget',
        sortable: true,
        align: 'left',
      }, // renamed in #4269
      {
        name: 'schemeName',
        label: 'Regeling',
        field: (row) =>
          row.schemeId != null && row.schemeIdoxKey != null
            ? row.schemeName
            : 'n.n.b',
        sortable: true,
        align: 'left',
      },
    ];

    const visibleColumns = ref([
      'actions',
      'organisation',
      'applicationNumber',
      'applicationSubject',
      'customer',
      'city',
      'applicationDescription',
      'dateGrantedString',
      'formattedAmount',
      'programTarget',
      'schemeName',
    ]);
    // 'themeArrangement'

    const pagination = ref({
      rowsPerPage: 25,
      page: 1,
      rowsNumber: 100000,
    });

    const errorOrganisation = ref(false);
    const errorOrganisationMessage = ref('');
    const errorApplicationNumber = ref(false);
    const errorApplicationNumberMessage = ref('');
    const errorApplicationSubject = ref(false);
    const errorApplicationSubjectMessage = ref('');

    onBeforeMount(() => {
      const fileId = route.params.fileId;
      store.commit('fileRecords/setFileId', fileId);
    });

    onMounted(async () => {
      const fileId = store.state.fileRecords.fileId;
      RecordsService.loadRecords(fileId, 1, 25);
    });

    const fileName = computed({
      get: () => store.state.fileRecords.fileName,
    });

    const areFileRecordsLoading = computed({
      get: () => store.state.fileRecords.areFileRecordsLoading,
    });

    const rows = computed({
      get: () => store.state.fileRecords.rows,
    });

    const doubleRows = computed({
      get: () => store.state.fileRecords.doubleRows,
    });

    const anyDoubleRows = computed({
      get: () => store.state.fileRecords.doubleRows.length > 0,
    });

    const selected = ref([]);

    const anySelected = computed({
      get: () => selected.value.length > 0,
    });

    const selectedDeleteRows = ref([]);
    const anythingSelectedForRemoval = computed({
      get: () => selectedDeleteRows.value.length > 0,
    });
    const confirmRemoveRecords = ref(false);

    const loading = ref(false);
    function onRequest(props) {
      const { page } = props.pagination;
      loading.value = true;
      const fileId = store.state.fileRecords.fileId;
      RecordsService.loadRecords(fileId, page, 25);
      pagination.value.page = page;
      loading.value = false;
    }

    const submitChanges = async (row) => {
      await RecordsService.updateRecord(row);
      row.editing = false;
    };

    return {
      loading,
      onRequest,
      fileName,
      areFileRecordsLoading,
      columns,
      visibleColumns,
      rows,
      doubleRows,
      anyDoubleRows,
      pagination,
      selected,
      anySelected,
      getSelectedString() {
        return selected.value.length === 0
          ? ''
          : `${selected.value.length} record${
              selected.value.length > 1 ? 's' : ''
            } geselecteerd van ${doubleRows.value.length}`;
      },
      addRecords() {
        const fileId = store.state.fileRecords.fileId;
        const recordIds = selected.value.map((a) => a.id);
        RecordsService.addRecords(fileId, recordIds);

        selected.value = [];
      },
      rejectRecords() {
        const fileId = store.state.fileRecords.fileId;
        const recordIds = selected.value.map((a) => a.id);
        RecordsService.rejectRecords(fileId, recordIds);

        selected.value = [];
      },

      selectedDeleteRows,
      anythingSelectedForRemoval,
      confirmRemoveRecords,
      errorOrganisation,
      errorOrganisationMessage,
      errorApplicationNumber,
      errorApplicationNumberMessage,
      errorApplicationSubject,
      errorApplicationSubjectMessage,
      submitChanges,
      removeRecords() {
        const fileId = store.state.fileRecords.fileId;
        const removeRecordIds = selectedDeleteRows.value.map((a) => a.id);
        RecordsService.removeRecords(fileId, removeRecordIds);

        // Reset selected rows to be removed
        selectedDeleteRows.value = [];
      },
      updateEditingState(row) {
        if (row.id != 0) {
          let obj = rows.value.find((el) => el.id === row.id);
          if (obj) {
            obj.editing = true;
          }
        }
      },
      organisationValidation(val) {
        if (val != null && val.length <= 0) {
          errorOrganisation.value = true;
          errorOrganisationMessage.value = 'Veld is verplicht!';
          return false;
        }
        errorOrganisation.value = false;
        errorOrganisationMessage.value = '';
        return true;
      },
      applicationNumberValidation(val) {
        if (val != null && val.length <= 0) {
          errorApplicationNumber.value = true;
          errorApplicationNumberMessage.value = 'Veld is verplicht!';
          return false;
        }

        errorApplicationNumber.value = false;
        errorApplicationNumberMessage.value = '';
        return true;
      },
      applicationSubjectValidation(val) {
        if (val != null && val.length <= 0) {
          errorApplicationSubject.value = true;
          errorApplicationSubjectMessage.value = 'Veld is verplicht!';
          return false;
        }
        errorApplicationSubject.value = false;
        errorApplicationSubjectMessage.value = '';
        return true;
      },
    };
  },
};
</script>
